import { cn } from '@utima/ui';
import { ChevronDown, ChevronUp } from 'lucide-preact';
import { useState, type ReactNode } from 'preact/compat';

type Props = {
  children: ReactNode;
  className?: string;
  title?: string;
};

export function Wrapper({ children, title, className }: Props) {
  const [isOpen, setIsOpen] = useState(!title);

  return (
    <div
      className={cn(
        'flex flex-col gap-3.5 rounded-[20px] border border-[#fff9] bg-[#ffffff6e] p-4',
        className,
      )}
    >
      {title && (
        <div className='flex items-center justify-between'>
          <span className='text-[14px] leading-[24px] text-[18181b]'>
            {title}
          </span>
          <button
            data-cta='web-input-wrapper-toggle-button'
            className='text-[#71717a]'
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? (
              <ChevronUp className='size-4' />
            ) : (
              <ChevronDown className='size-4' />
            )}
          </button>
        </div>
      )}
      {isOpen && children}
    </div>
  );
}
